import handler from "api/handler";

const prefix = "/public/seller";

const methods = {
  create: (data, config = {}) =>handler({ method: 'post', url: `${prefix}/create`, data, ...config }),
  getAllSellers: (params) =>handler({ method: 'get', url: `${prefix}/all`, params }),
  getSellerById: (id, config = {}) =>handler({ method: 'get', url: `${prefix}/${id}`, ...config }),
  update: (id, data, config = {}) =>handler({ method: 'put', url: `${prefix}/update/${id}`, data, ...config }),
  delete: (id, config = {}) =>handler({ method: 'delete', url: `${prefix}/delete/${id}`, ...config }),
};

export default methods;
